/**
 * Created by looch on 20/07/2017.
 */
const FOLDER_ALL = 'ALL'

export default FOLDER_ALL



// WEBPACK FOOTER //
// ./src/modules/Elements/Constants/folders.js